<template>
  <div class="content content--sub">
    <MyHeader :breadcrumbItems="[

        {
          name: 'Bookmarks',
          path: '/bookmarks'
        },
      ]"/>

    <header class="content-header">
      <h1>Bookmarks</h1>
      <button :class="['article-list-button', {active: showList}]" @click="showList = ! showList"><i class="icon-list"></i></button>
    </header>

    <!-- tabs for mobile -->
    <transition name="fade">
      <div class="article-list" v-if="showList">
        <div class="tabs-vertical">
          <ul class="tabs-inner">
            <li v-for="tab in tabs" :key="tab.id">
              <a :class="{'active': activeTab === tab.id}"  @click="activeTab = tab.id; showList = false">
                {{tab.name}}
                <i class="icon-arrow"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <div class="container main-content--tabbed">
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="tabs-vertical">
            <ul class="tabs-inner">
              <li v-for="(tab, index) in tabs" :key="tab.id">
                <a :class="{'active': isTabActive(tab, index)}" @click="selectTab(tab)">
                  {{tab.name}}
                  <i class="icon-arrow"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9">
            <NewsGrid box-class="col-lg-4" v-if="currentSelectedTab.code === 'NEWSFORYOU'" :boxes="tabBookmarks"></NewsGrid>
            <TeamMemberGrid box-class="col-lg-4" v-if="currentSelectedTab.code === 'MEETYOURTEAM'" :boxes="tabBookmarks"></TeamMemberGrid>
            <SolutionGrid box-class="col-lg-4" :slug="currentSelectedTab.slug" v-if="currentSelectedTab.code === 'SOLUTIONSCATEGORIES' || currentSelectedTab.code === 'SOLUTIONSFORYOU'" :boxes="tabBookmarks"></SolutionGrid>
            <ClientGrid box-class="col-lg-4" v-if="currentSelectedTab.code === 'CLIENTS'" :boxes="tabBookmarks"></ClientGrid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import {slugify} from "@/helpers/slugify";
import NewsGrid from "@/components/news/NewsGrid";
import TeamMemberGrid from "@/components/persons/TeamMemberGrid";
import SolutionGrid from "@/components/solutions/SolutionGrid";
import ClientGrid from "@/components/clients/ClientGrid";

export default {
  name: "Bookmarks",
  components: {ClientGrid, SolutionGrid, NewsGrid, MyHeader, TeamMemberGrid },
  data () {
    return {
      showList: false,
      activeTab: 1,
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Bookmarks']);
    window._paq.push(['trackPageView']);
  },
  computed: {
    tabs() {
      return this.$store.getters.bookmarksByCompanySections
    },
    tabBookmarks() {
      let type = ''
      if(this.currentSelectedTab.code === 'NEWSFORYOU') {
        type = 'News'
      }
      if(this.currentSelectedTab.code === 'MEETYOURTEAM') {
        type = 'TeamMember'
      }
      if(this.currentSelectedTab.code === 'SOLUTIONSCATEGORIES' || this.currentSelectedTab.code === 'SOLUTIONSFORYOU') {
        type = 'Solution'
      }
      if(this.currentSelectedTab.code === 'CLIENTS') {
        type = 'Client'
      }
      return this.currentSelectedTab.bookmarks.map(item => {
        let elem = JSON.parse(JSON.stringify(item._embedded[type]))
        elem._embedded = item._embedded
        return elem
      })
    },
    currentSelectedTab() {
      let index = 0;
      if(this.$route.query && this.$route.query.tab) {
        index = this.tabs.findIndex(item => {
          return slugify(item.name) === this.$route.query.tab
        })
      }
      if(index === -1) index = 0

      if(!this.tabs[index]) {
        return {}
      }

      this.selectTab(this.tabs[index])
      return this.tabs[index]
    }
  },
  methods: {
    slugify: slugify,
    selectTab(tab, subTab = null) {
      this.showList = false
      let query = {
        tab: tab.slug,
      }
      if(subTab) {
        query.subtab = slugify(subTab.name)
      }
      if(query.tab !== this.$route.query.tab || query.subtab ) {
        this.$router.push({query})
      }
    },
    isTabActive(tab, index) {
      return this.$route.query.tab ? (this.slugify(tab.name) === this.$route.query.tab) : index === 0
    },
  }
}
</script>
